export default (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  plusButton: {
    borderRadius: '50%',
    background: theme.color.grey_d3,
    width: 40,
    minWidth: 40,
    height: 40,
    marginRight: 15,
  },
  buttonLabel: {
    color: theme.color.green_7c,
  },
  icon: {
    fontSize: 20,
  },
});
